<mwe-modal [model]="popupModel()">
  <h1 class="h4">{{ title() | translate }}</h1>
  <p>{{ 'products.orderProducts.popup.description' | translate }}</p>
  <h2 class="h5">{{ 'products.orderProducts.popup.subTitle' | translate }}</h2>

  <div class="row g-4">
    <div class="col-lg-6">
      <mwe-clickable-products-card
        (cardClicked)="startNewClientProcess()"
        [categories]="[Sparte.Strom, Sparte.Gas, Sparte.Fernwaerme]"
        [hasAutoFocus]="true"
        [textNodeType]="'h3'"
        ariaTitle="newClient.title"
        dataTest="order-products-new-client"
      >
        <p class="text--legal mb-1">
          <span class="fw-semibold mb-0">{{ 'products.orderProducts.popup.newClient.stromGas' | translate }}</span> {{ stromCompany() }}
        </p>
        <p class="text--legal mb-0">
          <span class="fw-semibold">{{ 'products.orderProducts.popup.newClient.waerme' | translate }}</span> {{ waermeCompany() }}
        </p>
      </mwe-clickable-products-card>
    </div>

    <div class="col-lg-6">
      <mwe-clickable-products-card
        (cardClicked)="orderChargingCard()"
        [categories]="[Sparte.Emobility]"
        [textNodeType]="'h3'"
        ariaTitle="charging-card.order.entry"
        dataTest="order-products-emobility"
      >
        <p class="text--legal mb-0">{{ emobilityCompany() }}</p>
      </mwe-clickable-products-card>
    </div>

    @if (hasAllProducts()) {
      <div class="col-lg-6">
        <mwe-clickable-products-card
          (cardClicked)="startInternetProcess()"
          [categories]="[Sparte.Internet, Sparte.Iptv]"
          [categoryTranslationKeys]="internetCardCategoryTranslationKeys"
          [textNodeType]="'h3'"
          [ariaTitle]="internetAriaTitle()"
          dataTest="order-products-super-schnell"
        >
          <p class="mb-1">{{ 'products.orderProducts.popup.newClient.internetAdditionalInfo' | translate }}</p>
          <p class="text--legal mb-0">{{ internetCompany() }}</p>
        </mwe-clickable-products-card>
      </div>
    }
  </div>
</mwe-modal>
